import { IQuestionModel } from '@care-portals/api-interfaces';

type _ORG = {
  organization: string;
  label: string;
  pc_name: string;
  address?: string;
};

const orgs: _ORG[] = [
  {
    organization: 'momwell_cali',
    label: 'Momwell Cali',
    pc_name: 'Momwell Medical Group of California, P C.',
    address: '6469 Almaden Expressway Ste 80 #750 San Jose, CA 95120'
  },
  // {
  //   organization: 'momwell_digital',
  //   label: 'Momwell Digital',
  //   pc_name: 'Momwell'
  // },
  // {
  //   organization: 'momwell_ca_digital',
  //   label: 'Momwell CA Digital',
  //   pc_name: 'Momwell'
  // },
  {
    organization: 'momwell_ny',
    label: 'Momwell NY',
    pc_name: '9560 Medical, P.C.',
    address: '228 Park Ave S. #87963 New York, New York 10003-1502'
  },
  {
    organization: 'momwell_super',
    label: 'Momwell Super',
    pc_name: 'MOMWELL MEDICAL GROUP, PA',
    address: '6421 N Florida Ave. D-395 Tampa, FL 33604'
  },
  {
    organization: 'momwell',
    label: 'Momwell Arch',
    pc_name: 'Momwell'
  },
  {
    organization: 'happyasamother_co',
    label: 'Momwell Canada',
    pc_name: ' Momwell lnc.'
  }
];

const usBillingConsent = `
    <b>Virtual Therapy Fees</b>

    <ul>
      <li><b>Cash Pay Fee Range:</b> Each 50-minute session is priced between $150 and $220, varying by therapist.</li>
      <li><b>Payment Method:</b> We accept credit card payments, processed securely via Stripe after each session.</li>
      <li><b>Insurance:</b> Momwell offers In-networks services in select US states and insurance checks during a Free 15 minute consultation. During this consultation, you will be provided an estimated cost for therapy in the event your insurance doesn’t cover the entire amount. Momwell uses <a href="http://headway.co" target="_blank">Headway</a> for all insurance billing and fee collection for insurance sessions. See our <a href="https://www.momwell.com/pricing" target="_blank">pricing page</a> for an updated list of insurance providers we are in-network with.</li>
    </ul>
    
    <br />
    <b>Payment Responsibility</b>

    <p><b>Cash Pay:</b> You understand the fee structure and agree to pay in full at the conclusion of each session.</p>
    <p><b>Insurance:</b> You understand that you are responsible for any co-payment, coinsurance or deductible amounts as well as any cancellation fees (see cancellation policy below) for sessions as outlined in your <a href="http://headway.co" target="_blank">Headway</a> billing portal. Momwell can only provide an estimate of these fees during the Free consultation. Insurance providers can change plans and/or re-evaluate or audit submitted claims. Please be aware that insurance reimbursement is not guaranteed.</p>

    <br />
    <b>Therapy Cost Estimate</b>
    
    The cost of therapy depends on the hourly rate of the therapist and the number of sessions scheduled. While typically 6-10 sessions are recommended, the duration of therapy can be adjusted or terminated based on mutual agreement at any time.
    
    <br />
    <b>Out of Pocket Therapy Cost Estimate</b>
    
    The cost of therapy depends on the hourly rate of the therapist and the number of sessions scheduled. While typically 6-10 sessions are recommended, the duration of therapy can be adjusted or terminated based on mutual agreement at any time.
    
    <br />
    <b>Cancellation Policy</b>
    
    We require at least 24 hours notice to cancel or reschedule an appointment. Cancellations or changes made with less than 24 hours notice will incur a 50% cancellation fee of the scheduled service for cash pay clients and an $85 fee for insurance clients billed automatically at the time of the missed session or late cancellation.    
    
    <br />
    <b>Acknowledgment and signature</b>
    
    By signing below, you confirm that you have read and agree to the terms outlined above, including payment obligations and the cancellation policy. You also accept full responsibility for all charges incurred and for submitting insurance claims as needed.
    `;

const caBillingConsent = `
    <b>Virtual Therapy Fees</b>

    <ul>
      <li><b>Fee Range:</b> Each 50-minute session is priced between $150 and $220, varying by therapist.</li>
      <li><b>Payment Method:</b> We accept credit card payments, processed securely via Stripe after each session.</li>
      <li><b>Insurance:</b> Momwell does not directly bill insurance providers nor participate in any insurance networks. You are responsible for submitting any claims to your insurance company for potential reimbursement.</li>
    </ul>
    
    <br />
    <b>Payment Responsibility</b>

    You understand the fee structure and agree to pay in full at the conclusion of each session. Please be aware that insurance reimbursement is not guaranteed.

    <br />
    <b>Therapy Cost Estimate</b>
    
    The cost of therapy depends on the hourly rate of the therapist and the number of sessions scheduled. While typically 6-10 sessions are recommended, the duration of therapy can be adjusted or terminated based on mutual agreement at any time.
    
    <br />

    <b>Cancellation Policy</b>
    
    We require at least 24 hours notice to cancel or reschedule an appointment. Cancellations or changes made with less than 24 hours notice will incur a 50% cancellation fee of the scheduled service.

    <br />
    <b>Acknowledgment and signature</b>
    
    By signing below, you confirm that you have read and agree to the terms outlined above, including payment obligations and the cancellation policy. You also accept full responsibility for all charges incurred and for submitting insurance claims as needed.
    `;

const questionsModels: IQuestionModel[] = [
  {
    label: 'Consent Forms',
    educationalSlide: `
    Welcome to Momwell, your relationship with your therapist is both personal and professional and is crafted to support your mental health journey. This document outlines mutual expectations and provides structure to our therapy sessions. Please review this information carefully and discuss any questions with your therapist. Please note that our services are designed exclusively for individuals who are 18 years of age or older.

    
    <b>The Therapeutic Process</b>

    You have taken a positive step by choosing therapy at Momwell. While therapy can yield significant benefits like reduced distress and improved relationships, it may also evoke strong emotions and there's no guaranteed outcome. You have the right to withhold discussing any topic, pause, or terminate a session at any time. Our services are strictly therapeutic and are not intended for legal or forensic use. We are committed to ensuring that you feel comfortable and supported during this process.
    

    <b>Limitations of Confidentiality</b>

    Therapy is confidential, but certain disclosures are required by law, such as cases of child abuse, threats of harm to self or others, or under court orders. Our therapists are trained to handle such situations with care and will discuss any necessary disclosure with you beforehand.
    

    <b>Clinical Notes</b>

    All clinical notes are confidential and used solely for therapeutic purposes. Our policy is to not provide services for the purpose of resolving criminal charges or child custody/access cases. These notes are stored securely on our PIPEDA/HIPAA-compliant platform and retained for 10 years after the last treatment session.
    

    <b>Privacy and Sharing of Information</b>
    
    By agreeing to this consent, you authorize Momwell, its related entities, and its health professionals to manage your personal and medical information. Access to your full medical records is limited to your therapist, while administrative staff will handle your contact, billing, and scheduling details. Any sharing of information with third parties requires your explicit consent, except as outlined above in “Limitations of Confidentiality”.
    

    <b>Consent for Mental Health Treatment</b>

    You consent to undergo mental health evaluation and treatment by Momwell’s qualified staff. You acknowledge the potential risks and side effects of treatment, understanding that no guarantees can be made about the outcomes. You consent to the use and disclosure of your health information as necessary for your treatment.
    
    You may withdraw your consent at any time by providing written notice to privacy@momwell.com.
    
    
    <b>Acknowledgment and signature</b>
    
    By signing below, you confirm that you have read, understood, and discussed any questions regarding the contents of this Informed Consent for Therapy. You acknowledge your rights and responsibilities as outlined and agree to engage in the therapeutic process under these terms.
    `,
    field: 'InformedConsentForTherapy',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Print Name',
          type: 'text',
          placeholder: 'Please enter your name',
          name: 'name',
          halfWidth: true
        },
        {
          label: 'Signing Date',
          type: 'date',
          required: true,
          name: 'date',
          halfWidth: true
        },
        {
          label: 'Signature',
          type: 'esign',
          required: true,
          name: 'signature'
        }
      ]
    }
  },
  {
    label: 'Telehealth Consent',
    educationalSlide: `
    <b>Eligibility for Services</b>

    Our services are intended exclusively for adults. You must be 18 years of age or older to consent to and receive therapy through Momwell and its affiliates. 

    <b>Not a Crisis Service</b>

    By choosing to use this service, you confirm that you are not in a crisis situation. This service is not suitable for emergencies. If you are in crisis, please dial 911 or visit your nearest hospital. Alternatively, you can contact the Canadian Suicide Prevention Service at 1-833-456-4566 or the National Suicide Prevention Lifeline in the United States at 988, both available 24/7.

    <b>Termination of Services</b>

    At Momwell, we recognize that ending a therapeutic relationship can be challenging. We are committed to a respectful termination process, with the duration tailored by your therapist based on the length and intensity of your treatment. If treatment becomes ineffective or if there is a default in payment, your therapist will discuss alternatives with you and provide referrals to other qualified therapists if necessary. Additionally, if you do not schedule an appointment for eight consecutive weeks without prior arrangement, we may consider the professional relationship discontinued.

    <b>Use of Email</b>

    Momwell uses email for non-sensitive communication such as billing and scheduling only. Please do not send confidential health information via email, as it is not a secure method of transmission. By agreeing to this, you understand the confidentiality risks and assume responsibility for any personal health information you choose to communicate via email.

    <b>Technology Risks</b>

    By consenting to telehealth services, you agree to use the video-conferencing platform provided by Momwell for virtual sessions. You commit to maintaining confidentiality, using a secure internet connection, and ensuring privacy during sessions. Therapy sessions are not permitted to be recorded. You acknowledge that while telehealth provides many benefits, it also carries risks, including but not limited to, limitations in ensuring the privacy and security of online communications. Telehealth may also limit the therapist’s ability to make complete assessments as visual and olfactory observations are not always possible. You have the option to withdraw this consent at any time, effectively ending the telehealth services.

    For further details, please refer to our <a href="https://momwell.com/privacy-policy" target="_blank">Privacy Policy</a>.

    <b>Acknowledgment and signature</b>

    By signing this section, you affirm that you have fully read and understood the Telehealth Consent form. You recognize the specific terms regarding the use of telehealth services, the confidentiality and privacy risks associated with electronic communication, and your rights concerning the receipt and transmission of information. You agree to adhere to these terms for the duration of your use of telehealth services.
    `,
    field: 'TelehealthConsent',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Print Name',
          type: 'text',
          placeholder: 'Please enter your name',
          name: 'name',
          halfWidth: true
        },
        {
          label: 'Signing Date',
          type: 'date',
          required: true,
          name: 'date',
          halfWidth: true
        },
        {
          label: 'Signature',
          type: 'esign',
          required: true,
          name: 'signature'
        }
      ]
    }
  },
  {
    label: 'Billing Consent',
    educationalSlide: '',
    field: 'BillingConsent',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Print Name',
          type: 'text',
          placeholder: 'Please enter your name',
          name: 'name',
          halfWidth: true
        },
        {
          label: 'Signing Date',
          type: 'date',
          required: true,
          name: 'date',
          halfWidth: true
        },
        {
          label: 'Signature',
          type: 'esign',
          required: true,
          name: 'signature'
        }
      ]
    }
  },
  {
    label: 'Marketing Consent',
    educationalSlide: `
    <b>Partnership and Benefits</b>

    This Practice is committed to making motherhood easier by providing seamless care. We've partnered with Momwell, Inc., utilizing their platform to enhance your experience with services such as scheduling assistance, tailored email communications, and a unified user interface.


    <b>Authorization for Use or Disclosure of Protected Health Information (PHI)</b>

    By signing this form, you authorize {{PC_NAME}} to use and disclose your Protected Health Information (PHI) as defined under the Health Insurance Portability and Accountability Act of 1996 (HIPAA), as amended, and the Personal Health Information Protection Act of 2004 (PHIPA), as amended. This information may be used by Momwell, Inc. and its affiliates for precision care services, such as targeted promotions, education, and other communications.


    <b>Scope and Duration of Authorization</b>

    This authorization allows the named parties to use and disclose your PHI for three years, unless you choose to revoke it sooner.

    <b>Voluntary and Revocable Consent</b>

    Your consent is entirely voluntary and does not affect your treatment, payment, enrollment, or eligibility for benefits from {{PC_NAME}}. You have the right to revoke this authorization at any time by contacting our Privacy Officer at privacy@momwell.com. Please be aware that revocation will not affect any actions taken before the receipt of your revocation notice.
    `,
    field: 'MarketingConsent',
    type: 'info',
    answer: {
      type: 'list',
      items: [
        {
          label: 'Print Name',
          type: 'text',
          placeholder: 'Please enter your name',
          name: 'name',
          halfWidth: true
        },
        {
          label: 'Signing Date',
          type: 'date',
          required: true,
          name: 'date',
          halfWidth: true
        },
        {
          label: 'Signature',
          type: 'esign',
          required: true,
          name: 'signature'
        }
      ]
    }
  },
  {
    label: 'Acknowledgement of Notice of Privacy Practices',
    educationalSlide: `
    Our Notice of Privacy Practices can be found <a href="https://momwell.com/privacy-practices" target="_blank">here</a>.

    The Notice of Privacy Practices describes how Protected Health Information about you may be used and disclosed and how you can get access to this information. Please review it carefully. 

    We are required by law to protect the privacy of health information that may reveal your identity, and to provide you with a copy of this notice, which describes the health information privacy practices of our practice, its medical staff, and affiliated health care providers that jointly perform payment activities and business operations with our Practice. “Protected Health Information” is information about you, including demographic information that may identify you or your genetic information, and that relates to your past, present or future physical or mental health or condition and related health care services. 
    
    This Acknowledgement Form will become part of your permanent medical record.
    
    FOR MORE INFORMATION OR FURTHER QUESTIONS PLEASE CONTACT:
    
    <b>
    Practice Name:
    {{PC_NAME}}
    
    Privacy Officer 
    Contact Information: privacy@momwell.com
    </b>
    `,
    field: 'AckNOPP',
    type: 'info',
    answer: {
      type: 'consent-check',
      label:
        'I acknowledge that I have been presented with the notice of privacy practices.',
      name: 'AckNOPPConsent'
    }
  }
];

const getEducationalSlide = (org: _ORG, q: IQuestionModel) => {
  let educationalSlide: string;

  if (q.field == 'BillingConsent') {
    if (
      org.organization == 'momwell_cali' ||
      org.organization == 'momwell_ny' ||
      org.organization == 'momwell_super'
    ) {
      educationalSlide = usBillingConsent;
    } else {
      educationalSlide = caBillingConsent;
    }
  } else {
    educationalSlide = q.educationalSlide;
  }

  if (!educationalSlide) {
    return educationalSlide;
  }

  const renderedEducationalSlide = educationalSlide
    .replace(/{{PC_NAME}}/g, org.pc_name)
    .replace(/{{ADDRESS}}/g, org.address);

  return renderedEducationalSlide;
};

const momwellConsentQuestions = orgs
  .map(o =>
    questionsModels.map(q => ({
      ...q,
      educationalSlide: getEducationalSlide(o, q),
      field: o.organization + '_' + q.field
    }))
  )
  .flat();

export default momwellConsentQuestions;
